import pinterpolate from 'pinterpolate';

/**
 * Build supplied string by interpolating properties after delimiter(':') with the given parameters.
 *
 * @example
 * interpolate('/posts/:id', {id: 1})
 * => '/posts/1'
 *
 * @param {string} str
 * @param {object} params
 * @returns {string}
 */
export const interpolate = (str, params) => pinterpolate(str, params);

export const getFirstNameFromFullName = fullName => {
  return fullName.split(' ')[0];
};

export const getEmbedUrl = videoUrl => {
  const url = videoUrl.trim();
  if (isValidNaviSaviUrl(url) || isValidFirebaseUrl(url)) {
    return url;
  }
  let embedUrl = null;
  if (isValidYoutubeUrl(url)) {
    if (url.includes('watch?v=')) {
      let id = url.split('watch?v=')[1];
      if (id.includes('&')) {
        id = id.split('&')[0];
      }
      embedUrl = `https://www.youtube.com/embed/${id}`;
    } else {
      const urlSplit = url.split('/');
      const id = urlSplit.pop();
      embedUrl = `https://www.youtube.com/embed/${id}`;
    }
    embedUrl += `?version=3&enablejsapi=1&rel=0&autoplay=0&showinfo=0&controls=1&modestbranding=1`;
  }
  return embedUrl;
};

export const isValidYoutubeUrl = url => {
  const youtubeRegex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|shorts\/))((\w|-){11})(?:\S+)?$/;
  return youtubeRegex.test(url ? url.trim() : '');
};

export const isValidNaviSaviUrl = videoUrl => {
  const url = videoUrl ? videoUrl.trim() : '';
  if (url.slice(url.length - 4) === '.mp4') {
    return true;
  } else {
    return false;
  }
};

export const isValidFirebaseUrl = videoUrl => {
  // const firebaseRegex = /^(?:https?:\/\/)?firebasestorage[a-zA-Z.\/0-9\-%?=&]*/;
  const url = videoUrl ? videoUrl.trim() : '';
  return url.includes('firebasestorage'); // firebaseRegex.test(url ? url.trim() : '');
};

export const formatToTitleCase = string =>
  typeof string === 'string'
    ? string.replace(/\w\S*/g, text => text.charAt(0).toUpperCase() + text.substr(1).toLowerCase())
    : '';
